<template>
  <div class="selected-products-grid row">
    <div class="col-12">
      <h2>Ehdotetut tuotteet</h2>
    </div>
    <ProductLift
      v-for="product in getSortedProducts"
      :key="product"
      :product="getKalkkilaskuriProducts[product]"
      class="col-md-6 col-12 product"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductLift from "./ProductLift";

export default {
  name: "SelectedProductsGrid",
  components: { ProductLift },
  computed: {
    ...mapGetters(["getKalkkilaskuriProducts", "getSortedProducts"]),
  },
};
</script>

<style lang="scss" scoped>
h2 {
  color: var(--bs-dark);
}
</style>
